import React from 'react';
import {useSpring} from 'react-spring';

import {useTheme} from 'styled-components';

import {easing as bezierEasing} from '@edna/components/utils';

type TConfig = {
  isVisible: boolean;
  childrenHeight: number;
  easing?: ((t: number) => number) | null;
  hasOpacityDelay?: boolean;
  onClose?: TEmptyFunction;
};

export const useAppearStyles = ({
  isVisible,
  childrenHeight,
  easing = bezierEasing,
  hasOpacityDelay,
  onClose,
}: TConfig) => {
  const theme = useTheme();
  const duration = theme.animation.duration;

  const toConfig = React.useMemo(() => {
    if (hasOpacityDelay) {
      return [
        {
          maxHeight: isVisible ? childrenHeight : 0,
          overflow: isVisible ? 'visible' : 'hidden',
        },
        {
          opacity: isVisible ? 1 : 0,
          config: {duration: duration / 2},
        },
      ];
    }

    return [
      {
        opacity: isVisible ? 1 : 0,
        maxHeight: isVisible ? childrenHeight : 0,
        overflow: isVisible ? 'visible' : 'hidden',
      },
    ];
  }, [hasOpacityDelay, isVisible, childrenHeight, duration]);

  const styles = useSpring({
    from: {
      maxHeight: childrenHeight / 2,
      overflow: 'hidden',
      opacity: 0,
    },
    to: toConfig,
    update: {maxHeight: childrenHeight, config: {duration: 0}},
    config: {easing: easing ?? undefined, duration},
    onRest: (result) => {
      if (result.value.overflow === 'hidden') {
        onClose?.();
      }
    },
  });

  return styles;
};
